<div class="relative">
  <a
    target="_blank"
    *ngIf="!['image/png', 'image/jpeg', 'image/gif'].includes(file.mime); else imageFile"
    [href]="file | fileUrl | apiUrl">
    <i class="pi {{ file.mime | mime }} mr-1"></i>{{ file.name }}
  </a>
  <ng-template #imageFile>
    <crm-image
      [src]="file | fileUrl | apiUrl"
      width="80px"
      height="auto"></crm-image>
  </ng-template>
  <i
    *ngIf="canDelete"
    class="pi pi-times text-red-500 cursor-pointer absolute"
    style="top: -12px; right: -10px"
    (click)="delete.emit()">
  </i>
</div>
